var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Bar',{staticClass:"w-full h-96",attrs:{"chartOptions":_vm.chartOptions,"chartData":_vm.chartData,"aria-label":"Sales figures"}})
}
var staticRenderFns = []

export { render, staticRenderFns }